import Divider from "@mui/material/Divider";
import React from 'react';

const ResetMobilePassword = ({openMobileResetPassword}) => {
  return (
    <div className='mt-5'>
      <Divider
        sx={{
          color: '#3F4255',
          marginTop: '12px',
          marginBottom: '12px',
        }}
      />
      <div className="first_field_shabbat justify-content-end">
        <div 
          className="cursor-pointer"
          onClick={openMobileResetPassword}
          style={{
            borderBottom: '1px solid #3F4255',
          }}
        >Mobile App Password</div>
      </div>
    </div>
  )
}

export default ResetMobilePassword